import styled from "styled-components";
export const Buttons = styled.div `
  column-gap: 20px;
  display: grid;
  grid-template-columns: repeat(2, auto) 1fr;
  justify-items: start;
`;
export const Checkboxes = styled.div `
  column-gap: 20px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
`;
